import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Online from './Online'
import Analytics from 'react-router-ga'

class Monitoring extends React.Component{

    render(){
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <Analytics id="UA-123076872-5" debug>
                        <Switch>
                            <Route exact path={`/user-online`} component={Online}></Route>
                        </Switch>
                    </Analytics>
                </div>
            </div>
        );
    }

}

export default Monitoring;


// WEBPACK FOOTER //
// ./src/views/Monitoring/index.js